import AddSystemModal from './containers/AddSystemContainer'

export default AddSystemModal
